import axios from "axios";
import config from "@config";

const API = `${config.api}/reports`;

// Возвращает отчеты артиста
export const getReports = (params) =>
  axios
    .get(API, { params, withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });

// Возвращает отчет артиста
export const getReport = (params) =>
  axios
    .get(`${API}/id/${params.id}`, { params, withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });

// Подписывает отчет
export const signReport = (data) =>
  axios
    .post(`${API}/sign/${data.id}`, data, { withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });
